<template>
  <div style="height: 100%;">
    <div>
      <Header />
      <div class="main-wrapper plolicy-top-box width9440 service-box">
            <div class="search-box">
                <!-- <select>
                  <option>北京</option>
                  <option>上海</option>
                  <option>深圳</option>
                </select> -->
                <div class="search-input-box">
                  <input type="type" placeholder="请输入搜索内容" name="" v-model="searchkey">
                  <button @click="cliSearch">搜索</button>
                </div>
            </div>

            <div class="policy-main">
                <div class="policy-top-tab">
                    <!-- tab nav -->
                    <ViewTabList />
                    <!-- tab nav -->
                    <!-- 筛查条件pc -->
                    <div class="screening-box">
                        <div class="screen-items">
                            <p>分类：</p>
                            <div class="right-text">
                              <a href="javascript:;" @click.prevent="selCategery(index)" :class="selindex==index?'active':''" v-for="(item,index) in category">{{item}}</a>
                            </div>
                        </div>
                        <!-- <div class="screen-items">
                            <p>领域：</p>
                            <div class="right-text">
                              <a href="javascript:;" class="active">新基建</a>
                              <a href="javascript:;">数字云上</a>
                              <a href="javascript:;">智慧城市</a>
                              <a href="javascript:;">其他</a>
                            </div>
                        </div> -->
                    </div>
                    <!-- 筛查条件pc -->
                    <!-- 筛查条件-移动端 -->

                    <!-- 筛查条件-移动端 -->
                    <SearchCondition @activeItem="onActiveItem" @onselected="onConditionSelected" :items="initSearchCondition" :selectedKeys="selectedKeys"/>
                </div>

                <!-- 政策列表 -->
                <div class="policy-list policy-list-service" v-if="!hidelist">
                    <div @click="publishProject" class="consulting">发 布 需 求</div>
                    <ul>
                      <li class="policy-li" v-for="(item,index) in resultlist" :key="index" @click="openDetail(item.sid)">
                        <div class="left-txt">
                              <div class="img1">
                                 <img  :src="item.img">
                              </div>
                              <div class="service-title">
                                <h3>{{item.service_name}}</h3>
                                <p class="pp1">{{item.service_description}}</p>
                                <p class="pp2">发布时间:{{item.create_time}}</p>
                                <div class="btn-box">
                                    <a href="javascript:;">{{item.service_category}}</a>
                                    <a href="javascript:;">{{item.industry_category}}</a>
                                </div>
                              </div>
                        </div>
                        <div class="talent-plan">
                            <a href="javascript:;">{{item.province}}</a>
                        </div>
                      </li>

                    </ul>
                </div>
                <div class="paging-box">
                  <el-pagination layout="prev, pager, next" :page-size="limit" :total="count" @current-change="pagechange"></el-pagination>
                </div>
                <!-- 政策列表 -->
            </div>

      </div>
      <Footer :isLogin="true" />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import ViewTabList from '@/components/ViewTabList.vue';
import config from '@/config/index';
import { Pagination } from 'element-ui';

import SearchCondition from '@/components/SearchCondition.vue';
import {FinancialSearchCondition} from '@/const/FinancialSearchCondition.js'
import SearchConditionMixin from '@/mixins/SearchCondition.mixin.js'
import{
  searchorg,
  searchproduct,
  searchservice,
} from '@/api/searchOPP.js'
export default {
  mixins: [SearchConditionMixin],
    name: 'Financial',
    components: {
        Header,
        Footer,
        ViewTabList,
        [Pagination.name]: Pagination,
        SearchCondition,
    },
    watch: {
        $route(to, from) {}
    },
    data() {
        return {
          hidelist:false,
          initSearchCondition: FinancialSearchCondition,
          resultlist:[],
          page: 1,
          limit: 10,
          count: 0,
          searchkey:'',
          servicecategory:'金融服务',
          industrycategory:'',
          category:['全部','银行服务','风险投资','投资基金','融资担保','债券股票','民间借贷'],
          selindex:0,

        }
    },
    mounted() {
      this.queryFinancialservice()
    },
    methods: {
      cliSearch(){
        this.queryFinancialservice()
      },
      selCategery(index){
        this.selindex = index
        if(this.selindex==0){
          this.industrycategory=''
        }else{
          this.industrycategory=this.category[index]
        }
        this.queryFinancialservice()
      },
      publishProject() {
        this.$router.push('project-publish?type=project');
      },
      pagechange(page){
        this.page = page
        this.queryFinancialservice()
      },
      queryFinancialservice(){
        const servicecategory = this.servicecategory
        const industrycategory = this.industrycategory
        const page = this.page
        const limit = this.limit
        const searchkey = this.searchkey
        this.$http.get(searchservice(),{searchkey,servicecategory,industrycategory,page,limit}).then(res => {
            console.log(res);
            if (res.code === 1) {
                this.count = res.data.count
                this.resultlist = []
                var list = res.data.list
                var item;
                for(var i=0;i<list.length;i++){
                  item = list[i]
                  var img = JSON.parse(item.img)[0]
                  item.img = `${config.HOST_IMG}${img}`
                   this.resultlist.push(item)
                }
            } else {
                this.$message.warning(res.msg);
            }
        });
      },
      openDetail(sid){
        this.$router.push("/detail/service?sid="+sid)
      },
      toogleListShow(hide){
        this.hidelist = hide
        console.log(this.selectedKeys)
        if(hide==false){
          this.selectedKeys.forEach(item=>{
            if(item.item.index==0){
              this.industrycategory=''
            }else{
              this.industrycategory=item.key
            }
          })

          this.queryFinancialservice()
        }
      }
    }
}
</script>

<style scoped>
  @import url(./Policy.css);
  @import url(./service.css);
  .paging-box{
      text-align: center;
      /* margin: 30px 0 30px 140px; */
      overflow: hidden;
  }
</style>
